import {RadioactivityUomCd} from '../';
import {EnumHelper} from './enum-helper';

export class RadioactivityUomCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in RadioactivityUomCd ) {
      this._values.push(RadioactivityUomCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): RadioactivityUomCd {

    for ( const obj in RadioactivityUomCd ) {
      if (RadioactivityUomCd[obj] === value){
        return RadioactivityUomCd[obj] as RadioactivityUomCd;
      }
    }
  }
}

const RadioactivityUomCdHelper = new RadioactivityUomCdHelperEnumHelperClass();
export default RadioactivityUomCdHelper;
